<template>
    <CieloLayout>
        <div class="cpt">
            <TitleText class="spacing-b-6" level="2">
                {{ $ml.get('changePixTypeTitle') }}
            </TitleText>

            <ul class="cpt__list" tabindex="0">
                <li
                    class="cpt__list-item"
                    v-for="(paymentType, index) in availablePixPaymentTypes"
                    :key="index"
                >
                    <button
                        class="pix-type"
                        @click="handePaymentType(paymentType)"
                    >
                        <img class="pix-type__img" :src="paymentType.PixTypeIcon" alt="" tabindex="-1" />

                        <p class="pix-type__info">
                            <span
                                class="pix-type__name"
                                v-text="paymentType.PixTypeTitle"
                            />
                            <small v-if="paymentType.Text" class="pix-type__text">
                                <span v-text="$ml.get(paymentType.PixTypeText)" />
                            </small>
                        </p>

                        <small 
                            v-if="paymentType.Badge" 
                            :class="`pix-type__badge pix-type__badge--${paymentType.Badge}`"
                            v-text="$ml.get(paymentType.Badge)" 
                        />
                        <img class="pix-type__chevron" src="@/assets/img/icons/arrow-right-gray.svg" alt="" tabindex="-1" />
                    </button>
                </li>
            </ul>

            <div class="cpt__op-info">
                <strong v-text="$ml.get('changePixTypeOpenFinanceInfo1')" tabindex="0" />
                <span v-text="$ml.get('changePixTypeOpenFinanceInfo2')" tabindex="0" />
            </div>
        </div>

        <CieloButton @click="goToPreviousPage" :transparent="true">
            <span :style="{ 'font-weight': 600 }" v-text="$ml.get('back')" />
        </CieloButton>
    </CieloLayout>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { logEvent } from '@/helpers/cieloLogger';

    const CieloLayout = () => import(
        /* webpackChunkName: "cielo-layout" */ '@/components/layout/CieloLayout'
    );
    const CieloButton = () => import(
        /* webpackChunkName: "cielo-button" */ '@/components/template/CieloButton'
    );
    import TitleText from '@/components/template/TitleText';

    export default {
        components: {
            CieloLayout,
            CieloButton,
            TitleText
        },

        mounted() {
            this.$store.commit('payment/resetPaymentMethod');
        },

        computed: {
            ...mapGetters({
                availablePixPaymentTypes: 'paymentTypes/getPixTypes',
            })
        },

        methods: {
            handePaymentType(paymentType) {

                logEvent({
                    category: 'checkout',
                    action: 'selecao_pagamento',
                    label: `PaymentType: ${paymentType.Id}`
                });

                this.$store.commit('payment/setPaymentType', paymentType.Id);
                this.$store.commit('payment/setDiscount', paymentType.discount);

                if (paymentType.paymentMethodId) {
                    this.$store.dispatch(
                        'payment/setPaymentMethod',
                        paymentType.paymentMethodId,
                        { root: true }
                    );
                }

                this.$store.dispatch('pipeline/pushTo', paymentType.PixTypeStartView);
            },

            goToPreviousPage() {
                this.$store.dispatch('pipeline/pushTo', 'ChangePaymentType');
            },
        }
    };
</script>

<style scoped lang="scss">
    .cpt {
        margin-bottom: 32px;

        @media screen and (max-width: 1024px) {
            display: flex;
            flex-direction: column;
            flex: 1 0 auto;
        }

        &__list {
            list-style-type: none;
            padding: 0;
        }

        &__op-info {
            padding: 16px;
            border-radius: 12px;
            background-color: #EFF1F3;
            margin-top: 32px;
            strong,
            span {
                font-size: 14px;
                display: block;
            }
        }
    }

    .pix-type {
        display: flex;
        align-items: center;
        position: relative;
        padding: 20px 0px;
        background-color: transparent;
        border: none;
        border-bottom: 1px solid #B8C1CC;
        width: 100%;

        &:hover,
        &:focus {
            background-color: #EFF1F3;
        }

        &__img {
            width: 24px;
            height: 24px;
            margin-right: 12px;
        }

        &__info {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            margin-bottom: 0;
        }

        &__name {
            font-size: 16px;
            font-weight: 600;
            line-height: 10px;
            color: #2F363E;
        }

        &__text {
            font-size: 14px;
            font-weight: 500;
            line-height: 10px;
            color: #5C6A7B;
            margin-top: 12px;
        }

        &__badge {
            position: absolute;
            top: 50%;
            right: 41px;
            transform: translateY(-50%);
            background-color: #9747FF29;
            color: #5B169C;
            padding: 6px 8px;
            font-size: 14px;
            font-weight: 600;
            line-height: 16px;
            border-radius: 8px;
        }

        &__badge--recommendedBadge{
            right: 0;

            & + .pix-type__chevron {
                display: none;
            }
        }

        &__chevron {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translateY(-50%);
            width: 24px;
            height: 24px;
        }
    }
</style>
